import httpService from "services/httpService";
import { NewWebhook } from "./types";

const webhookRoutes = {
  addWebhook: "/assistants/webhooks/whitelabelsubscribe",
  removeWebhook: "/assistants/webhooks/whitelabelUnsubscribe",
  updateWebhook: "/assistants/webhooks/whitelabelEdit"
} as const;

interface AddWebhookPOSTRequest {
  body: NewWebhook;
}

function addWebhookPOST(request: AddWebhookPOSTRequest) {
  const { body } = request;
  return httpService.post(`${webhookRoutes.addWebhook}`, body);
}

interface RemoveWebhookDELETERequest {
  params: {
    workspaceId: string;
    assistantId: string;
    webhookId: string;
  };
}

function removeWebhookDELETE(request: RemoveWebhookDELETERequest) {
  const { params } = request;
  return httpService.delete(
    `${webhookRoutes.removeWebhook}/${params.workspaceId}/${params.assistantId}/${params.webhookId}`,
  );
}

interface UpdateWebhookPUTRequest {
  params: {
    workspaceId: string;
    assistantId: string;
    webhookId: string;
  };
  body: NewWebhook;
}

function updateWebhookPUT(request: UpdateWebhookPUTRequest) {
  const { params, body } = request;

  return httpService.put(
    `${webhookRoutes.updateWebhook}/${params.workspaceId}/${params.assistantId}/${params.webhookId}`,
    body,
  );
}

export { addWebhookPOST, removeWebhookDELETE, updateWebhookPUT };
